import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useField } from "formik";


function SearchableSelect({ label, data = [], fullWidth, required, placeholder = "Select an option", name }) {
  const [field, meta, helpers] = useField(name);
  const showError = meta.touched && meta.error;
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);


   const getFontSize = () => {
    const width = window.innerWidth;
    if (width < 480) return "0.75rem";
    if (width < 768) return "0.875rem";
    return "1rem";
  };
  // keep the input text synced with selected value
  useEffect(() => {
    const selected = data.find((d) => d.value === field.value);
    setQuery(selected ? selected.label : "");
  }, [field.value, data]);

  // close on outside click
  useEffect(() => {
    function onDocClick(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const filtered = query
    ? data.filter((d) => d.label.toLowerCase().includes(query.toLowerCase()))
    : data;

  return (
    <div className={`mb-3 ${fullWidth ? "col-md-12" : "col-md-6"}`} ref={containerRef}>
      {label && (
        <label className="form-label  d-block" htmlFor={name} style={{ fontSize: getFontSize() }}>
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
      )}

      <div className={`position-relative`}>
        <input
          id={name}
          name={name}
          className={`form-control ${showError ? "is-invalid" : ""}`}
          placeholder={placeholder}
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
          autoComplete="off"
        />

        {open && (
          <div className="card position-absolute w-100" style={{ zIndex: 1000, maxHeight: 220, overflowY: "auto" }}>
            <ul className="list-group list-group-flush">
              {filtered.length === 0 && (
                <li className="list-group-item text-muted">No results</li>
              )}
              {filtered.map((item, i) => (
                <li
                  key={i}
                  className="list-group-item list-group-item-action"
                  role="button"
                  onMouseDown={(ev) => {
                    // use onMouseDown so it triggers before blur
                    ev.preventDefault();
                    helpers.setValue(item.value);
                    setQuery(item.label);
                    setOpen(false);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
        )}

        {showError && <div className="invalid-feedback d-block">{meta.error}</div>}
      </div>
    </div>
  );
}

SearchableSelect.propTypes = {
  label: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  name: PropTypes.string.isRequired,
};

export default SearchableSelect;
